import { Component } from '@angular/core'
import { AuthService } from '@spartacus/core'
import { Router } from '@angular/router'
import { MbLogoutService } from '../../../shared/services/mb-logout/mb-logout.service'
import { switchMap, take } from 'rxjs/operators'
import { from } from 'rxjs'

@Component({
  selector: 'mb-myaccount-logout',
  templateUrl: './mb-myaccount-logout.component.html',
  styleUrls: ['./mb-myaccount-logout.component.scss'],
})
export class MbMyaccountLogoutComponent {

  constructor (protected authService: AuthService,
              protected mbLogoutService: MbLogoutService,
              protected router: Router) {
  }

  onLogout () {
    return this.authService.isUserLoggedIn() && this.mbLogoutService.logout().pipe(
      take(1),
      switchMap(() => from(this.router.navigateByUrl('/')))
    ).subscribe()
  }
}
